module.exports = __webpack_public_path__ + "img/PP.0fcffa98.png";